import SubscriptionItemContainer from './SubscriptionItemContainer.js';
export default SubscriptionItemContainer;